import { ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';

import { IModalDialogOptions } from '@app/shared/types/ui/modal-options.type';
import {
  BTN_DONE,
  BTN_CANCEL,
} from '@app/text-content/button-templates/button-templates-content';
import { WIDGET_COMPONENT } from '@app/shared/types/enums/widget-component.enum';
import { WIDGET_FAMILY } from '@config/global-constants';
import { I18n } from '@app/i18n/strings-keys';
import { rx } from '@app/shared/rx';
import { ICommissionRateFormAddition } from '@shared/types';

export const getCommissionRateAssignmentDefinition = (
  options: {
    formAddition: ICommissionRateFormAddition;
    validators?: Record<string, ValidatorFn[]>;
    subTitle?: string | Observable<string>;
    title?: string;
  },
  on?: {
    beforeFormClose?: IModalDialogOptions['beforeFormClose'];
  },
): IModalDialogOptions => {
  const { formAddition } = options;

  return {
    modalClass: 'modal-hg commission-rate-assignment-modal no-padding-modal',
    buttons: [
      {
        ...BTN_DONE,
        caption: I18n.Common.Save,
        disabledObs: formAddition.canSaveObs.pipe(
          rx.map((canSave) => !canSave),
        ),
      },
      BTN_CANCEL,
    ],
    validation: true,
    showPristineError: true,
    schema: {
      type: 'object',
      properties: {
        commission_rates: {
          type: 'array',
        },
      },
    },
    formRules: {
      fields: {
        commission_rates: {
          title:
            options?.title ||
            I18n.Forms.HawkerProfileForm.CommissionRateAssignment,
          ignoreAutoTitleWhenTranslate: true,
          class: 'commission-rate-grid',
          widgetFamily: WIDGET_FAMILY.XUX,
          widget: WIDGET_COMPONENT.commission_rate_assignment_grid,
          widgetData: {
            employee_id: formAddition.employeeId,
            canSaveObs: formAddition.canSaveObs,
            isAssignmentGridChangeObs: formAddition.isAssignmentGridChangeObs,
            handleAssignmentGridSaveObs:
              formAddition.handleAssignmentGridSaveObs,
          },
        },
      },
      defaultGroup: true,
    },
    beforeFormClose: on?.beforeFormClose,
  };
};
